import React,{ useState, useEffect } from "react";
import axios from "../../utils/axios";
import { notifyError } from "../../utils/toastError";
import BugBountyCard from "./BugBountyCard";

const BugBounty = () => {
  const [bugBounties, setbugBounties] = useState([]);

  // const host = "https://admin-d.herokuapp.com";

  const getBugBounty = async () => {
    try {
      const response = await axios.get(`api/bugbounty/getbugbounty`);
      const data = response.data;
      if (data.success) {
        setbugBounties(data.bugbounty);
      }
      else {
        notifyError("Error Getting Bug Bounty");
      }
    } catch (error) {
      console.log(error.message);
      notifyError("Error fetching bug bounties");
    }
  };

  useEffect(() => {
    getBugBounty();
  }, []);


  
  return (
    <>
    <h2 className="text-3xl text-center sm:text-left sm:text-4xl mt-10  text-lyellow sm:px-[2.3em] font-semibold">Bug Bounty</h2>
      <div className="flex flex-col justify-center items-center md:grid md:grid-cols-1 lg:grid-cols-2">
        {
          bugBounties.length>0 ? bugBounties.map(bugbounty => (
            <BugBountyCard key={bugbounty._id} {...bugbounty} />
          )) 
          : <>
            <BugBountyCard title="Bug Bounty" email="demo@demo.com" prize={0} detail="Coming Soon" />
            <BugBountyCard title="Bug Bounty" email="demo@demo.com" prize={0} detail="Coming Soon" />
          </>
        }
        
      </div>
      <div className="flex justify-center items-center">
        <div className="w-11/12 h-[0.2px] border-t border-lyellow" />
      </div>
    </>
  );
};

export default BugBounty;
